import React, { Component } from "react";
import PropTypes from "prop-types";
import { injectIntl, intlShape, FormattedMessage } from "react-intl";
// import { compose } from "recompose";
import { connect } from "react-redux";
import cx from "classnames";
import { submit } from "redux-form";
import { PanelCard, Button } from "cxa-components";
import withMatchMediaProps from "@hocs/with-match-media-props";
import messagesDescription from "components/messagesDescription";
import {
  getRootMessages,
  searchMessages,
  postMessage,
  onConfirmPost,
} from "actions/messagingActions";
import { compose } from "cxa-utils";
// import HomeContainerToolbarForm from "./HomeContainerToolbarForm";
import MessageCard from "./MessageCard";
import MessageReadingPane from "./MessageReadingPane";
import ComposeMessageContainer from "./ComposeMessageContainer";
import MessageConfirmDialog from "./MessageConfirmDialog";

class HomeContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isComposeMessage: false,
      isReadingMode: true,
      isReadingMessage: true,
      isReplyMessage: false,
      selectedMessage: {},
      selectedMessageIndex: 0,
    };

    this.onComposeMessage = this.onComposeMessage.bind(this);
    this.onSelectMessage = this.onSelectMessage.bind(this);
    this.onReplyMessage = this.onReplyMessage.bind(this);
    this.closeConfirmDialog = this.closeConfirmDialog.bind(this);
    this.onGoBack = this.onGoBack.bind(this);
    this.messageCardListVisible = this.messageCardListVisible.bind(this);
    this.readingPaneVisible = this.readingPaneVisible.bind(this);
    this.onNextMessage = this.onNextMessage.bind(this);
    this.onPreviousMessage = this.onPreviousMessage.bind(this);
    // this.onSearch = this.onSearch.bind(this);
  }

  componentDidMount() {
    this.props.getRootMessages();
  }

  componentDidUpdate() {
    const { selectedMessage } = this.state;
    const {
      rootMessages: { messages },
    } = this.props;

    if (!selectedMessage.pkMessage && messages && messages.length) {
      this.setState({
        selectedMessage: messages[0],
      });
    }
  }

  // onSearch(e) {
  //   const keyWord = e.search;
  //   if (keyWord && keyWord.trim().length > 0) {
  //     this.props.searchMessages(keyWord.trim());
  //   } else {
  //     this.props.getRootMessages();
  //   }
  // }

  onSelectMessage = selectedMessage => () => {
    const {
      rootMessages: { messages },
    } = this.props;

    this.setState({
      isComposeMessage: false,
      isReadingMode: true,
      isReadingMessage: true,
      isReplyMessage: false,
      selectedMessage,
      selectedMessageIndex: messages.findIndex(m => m.pkMessage === selectedMessage.pkMessage),
    });
  };

  onGoBack() {
    this.setState({
      isComposeMessage: false,
      isReadingMode: true,
      isReadingMessage: false,
      isReplyMessage: false,
    });
  }

  onComposeMessage() {
    this.setState({
      isComposeMessage: true,
      isReadingMode: true,
      isReadingMessage: false,
      isReplyMessage: false,
    });
  }

  onReplyMessage() {
    this.setState({
      isComposeMessage: false,
      isReadingMode: true,
      isReadingMessage: false,
      isReplyMessage: true,
    });
  }

  onNextMessage(evt) {
    const currentIndex = this.state.selectedMessageIndex;
    const {
      rootMessages: { messages },
    } = this.props;

    if (currentIndex < messages.length - 1) {
      this.setState({
        isComposeMessage: false,
        isReadingMode: true,
        isReadingMessage: true,
        isReplyMessage: false,
        selectedMessageIndex: currentIndex + 1,
        selectedMessage: messages[currentIndex + 1],
      });
    }

    evt.preventDefault();
  }

  onPreviousMessage(evt) {
    const currentIndex = this.state.selectedMessageIndex;
    const {
      rootMessages: { messages },
    } = this.props;

    if (currentIndex > 0) {
      this.setState({
        isComposeMessage: false,
        isReadingMode: true,
        isReadingMessage: true,
        isReplyMessage: false,
        selectedMessageIndex: currentIndex - 1,
        selectedMessage: messages[currentIndex - 1],
      });
    }

    evt.preventDefault();
  }

  closeConfirmDialog() {
    this.props.onConfirmPost();
    this.setState({
      isComposeMessage: false,
      isReadingMode: true,
      isReadingMessage: true,
      isReplyMessage: false,
    });
  }

  handleCancel = () => {
    this.setState({
      isComposeMessage: false,
      isReadingMode: true,
      isReadingMessage: true,
      isReplyMessage: false,
    });
  };

  messageCardListVisible() {
    const { isPhoneScreen, isTabletScreen } = this.props;
    const { isComposeMessage, isReadingMode, isReadingMessage, isReplyMessage } = this.state;
    const isNarrowScreen = isPhoneScreen || isTabletScreen;

    if (isReadingMessage || isReadingMode) {
      return (
        (isReadingMessage && !isNarrowScreen) ||
        !(isReadingMessage && isNarrowScreen) ||
        (isReadingMode && !isNarrowScreen)
      );
    }

    return (isComposeMessage && !isNarrowScreen) || (!isNarrowScreen && isReplyMessage);
  }

  readingPaneVisible() {
    const { isPhoneScreen, isTabletScreen } = this.props;
    const { isReadingMessage, isReplyMessage } = this.state; // isComposeMessage, isReadingMode,
    const isNarrowScreen = isPhoneScreen || isTabletScreen;

    return (
      (isReadingMessage && isNarrowScreen) ||
      (!this.messageCardListVisible() && isReadingMessage) ||
      (isReadingMessage && !isNarrowScreen) ||
      isReplyMessage
    );
  }

  render() {
    const {
      intl,
      isPhoneScreen,
      isTabletScreen,
      rootMessages: { messages, byId },
      showDialog,
      postMessageRemote,
      isWriteEnabled,
    } = this.props;
    const {
      isComposeMessage,
      isReadingMode,
      isReadingMessage,
      isReplyMessage,
      selectedMessage,
      selectedMessageIndex,
    } = this.state;

    const isNarrowScreen = isPhoneScreen || isTabletScreen;
    // const isMessageCardListVisible = this.messageCardListVisible();
    // const showToolbar = (isReadingMode && isNarrowScreen) || !isNarrowScreen;
    const showNavBar = isNarrowScreen && (isReplyMessage || isComposeMessage || isReadingMessage);
    const isReadingPaneVisible = this.readingPaneVisible();
    const messageListClassName = isPhoneScreen
      ? cx("panel-card__wrapper cxa-grid__item cxa-grid__item--eight")
      : cx("panel-card__wrapper cxa-grid__item cxa-grid__item--four");

    return (
      <div>
        <MessageConfirmDialog
          messageTitle={intl.formatMessage(
            messagesDescription.inAppMessages.messageSentDialogTitle
          )}
          messageContent={intl.formatMessage(
            messagesDescription.inAppMessages.messageSentDialogContent
          )}
          isOpen={showDialog}
          close={this.closeConfirmDialog}
        />
        <div className="o-layout apl-in-app-messages">
          <div className="o-layout__item">
            <header>
              <h2>
                <FormattedMessage {...messagesDescription.inAppMessages.messages} />
              </h2>
            </header>
            {/* {showToolbar && (
              <PanelCard>
                <HomeContainerToolbarForm onSubmit={this.onSearch} />
              </PanelCard>
            )} */}
            <div className="cxa-grid__wrapper apl-in-app-messages__wrapper">
              {showNavBar && (
                <Button
                  className="apl-in-app-messages__button cxa-grid__item cxa-grid__item--three"
                  onClick={this.onGoBack}
                  secondary
                >
                  {`<  ${intl.formatMessage(messagesDescription.inAppMessages.messagesList)}`}
                </Button>
              )}
              {showNavBar &&
                isReadingMessage && (
                  <div className="apl-in-app-messages__nav cxa-grid__item cxa-grid__item--five">
                    <a
                      className={cx("apl-in-app-messages__nav--item", {
                        "apl-in-app-messages__nav--item__disabled": selectedMessageIndex <= 0,
                      })}
                      onClick={this.onPreviousMessage}
                      secondary
                    >
                      {`< ${intl.formatMessage(messagesDescription.previousTextDescription)}`}
                    </a>
                    <a
                      className={cx("apl-in-app-messages__nav--item", {
                        "apl-in-app-messages__nav--item__disabled":
                          selectedMessageIndex >= messages.length - 1,
                      })}
                      onClick={this.onNextMessage}
                      secondary
                    >
                      {`${intl.formatMessage(messagesDescription.nextTextDescription)} >`}
                    </a>
                  </div>
                )}
              <PanelCard className={messageListClassName}>
                {!isPhoneScreen &&
                  isWriteEnabled && (
                    <PanelCard>
                      <Button primary onClick={this.onComposeMessage}>
                        <FormattedMessage
                          {...messagesDescription.inAppMessages.composeNewMessage}
                        />
                      </Button>
                    </PanelCard>
                  )}
                {messages.length > 0 &&
                  (!isPhoneScreen ||
                    (!isReadingMessage && !isComposeMessage && !isReplyMessage)) && (
                    <section className="message-card__list">
                      <ul className="in-app-messages">
                        {messages.map((message, idx) => (
                          <MessageCard
                            key={message.id}
                            onClick={this.onSelectMessage}
                            isSelected={
                              selectedMessage.pkMessage
                                ? selectedMessage.pkMessage === message.pkMessage
                                : idx === 0
                            }
                            {...message}
                          />
                        ))}
                      </ul>
                    </section>
                  )}
              </PanelCard>

              <PanelCard className="cxa-grid__item cxa-grid__item--eight">
                {isReadingPaneVisible &&
                  messages.length > 0 && (
                    <MessageReadingPane
                      isReplyMessage={isReplyMessage}
                      isReadingMode={isReadingMessage}
                      isComposeMessage={isComposeMessage}
                      onReplyMessage={this.onReplyMessage}
                      isNarrowScreen={isNarrowScreen}
                      selectedMessage={byId[selectedMessage.pkMessage]}
                    />
                  )}
                <ComposeMessageContainer
                  isComposeMessage={isComposeMessage}
                  isNarrowScreen={isNarrowScreen}
                  onCancel={this.handleCancel}
                />
              </PanelCard>
            </div>
            {isWriteEnabled &&
              isNarrowScreen &&
              (isComposeMessage || isReplyMessage || isReadingMode) && (
                <PanelCard className="apl-in-app-messages apl-in-app-messages__control--sticky">
                  {isReadingMode &&
                    !isComposeMessage &&
                    !isReplyMessage && (
                      <Button primary onClick={this.onComposeMessage}>
                        <FormattedMessage
                          {...messagesDescription.inAppMessages.composeNewMessage}
                        />
                      </Button>
                    )}
                  {isWriteEnabled &&
                    (isComposeMessage || isReplyMessage) && (
                      <Button primary onClick={postMessageRemote}>
                        <FormattedMessage id="Send" />
                      </Button>
                    )}
                </PanelCard>
              )}
          </div>
        </div>
      </div>
    );
  }
}

HomeContainer.propTypes = {
  intl: intlShape.isRequired,
  isReadEnabled: PropTypes.bool,
  isWriteEnabled: PropTypes.bool,
  isPhoneScreen: PropTypes.bool,
  isTabletScreen: PropTypes.bool,
  isReplyMessage: PropTypes.bool,
  isReadingMessage: PropTypes.bool,
  getRootMessages: PropTypes.func.isRequired,
  rootMessages: PropTypes.object,
  postMessage: PropTypes.func,
  onConfirmPost: PropTypes.func,
  showDialog: PropTypes.bool,
  postMessageRemote: PropTypes.func,
  searchMessages: PropTypes.func,
};

const mapStateToProps = ({
  common: {
    messaging: {
      menu: { isReadEnabled = true, isWriteEnabled = true },
    },
  },
  messaging: {
    rootMessages: { byId, messages = [] } = {},
    MESSAGING_ON_POST_MESSAGE_SUCCESS,
    MESSAGING_POST_MESSAGE_SUCCESS,
  } = {},
}) => {
  // set default selectedMessage
  return {
    isReadEnabled,
    isWriteEnabled,
    rootMessages: {
      messages,
      byId,
    },
    messages,
    byId,
    showDialog: MESSAGING_ON_POST_MESSAGE_SUCCESS && !MESSAGING_POST_MESSAGE_SUCCESS,
  };
};

const mapDispatchToProps = {
  getRootMessages,
  searchMessages,
  postMessage,
  onConfirmPost,
  postMessageRemote: () => dispatch => {
    dispatch(submit("ComposeMessageForm"));
  },
};

export default compose(
  withMatchMediaProps({
    isTabletScreen: {
      maxWidth: 719,
      minWidth: 420,
    },
    isPhoneScreen: {
      maxWidth: 419,
    },
  }),
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(HomeContainer);



// WEBPACK FOOTER //
// ./components/inAppMessages/HomeContainer.js